import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import MainLayout from './layouts/MainLayout';
import LoginPage from './pages/LoginPage';
import ScheduleDemoPage from './pages/ScheduleDemoPage';
import DashboardPage from './pages/DashboardPage';
import ProductsPage from './pages/ProductsPage';
import CategoriesPage from './pages/CategoriesPage';
import UnitsPage from './pages/UnitsPage';
import WarehousesPage from './pages/WarehousesPage';
import SuppliersPage from './pages/SuppliersPage';
import CustomersPage from './pages/CustomersPage';
import UsersPage from './pages/UsersPage';
import RolesPage from './pages/RolesPage';
import StockPage from './pages/StockPage';
import StockCardPage from './pages/StockCardPage';
import StockOpnamePage from './pages/StockOpnamePage';
import StockTransferPage from './pages/StockTransferPage';
import StockInPage from './pages/StockInPage';
import StockOutPage from './pages/StockOutPage';
import PurchaseRequestsPage from './pages/PurchaseRequestsPage';
import PurchaseOrdersPage from './pages/PurchaseOrdersPage';
import PurchaseReceiptsPage from './pages/PurchaseReceiptsPage';
import PurchaseInvoicesPage from './pages/PurchaseInvoicesPage';
import PurchaseReturnsPage from './pages/PurchaseReturnsPage';
import SalesNewPage from './pages/SalesNewPage';
import SalesHistoryPage from './pages/SalesHistoryPage';
import SalesInvoicesPage from './pages/SalesInvoicesPage';
import SalesReturnsPage from './pages/SalesReturnsPage';
import CashBankPage from './pages/CashBankPage';
import PayablesPage from './pages/PayablesPage';
import ReceivablesPage from './pages/ReceivablesPage';
import SalesReceivablesPage from './pages/SalesReceivablesPage';
import AccountsPage from './pages/AccountsPage';
import JournalsPage from './pages/JournalsPage';
import AccountingPeriodsPage from './pages/AccountingPeriodsPage';
import ProfitLossPage from './pages/ProfitLossPage';
import BalanceSheetPage from './pages/BalanceSheetPage';
import EquityReportPage from './pages/EquityReportPage';
import GeneralLedgerPage from './pages/GeneralLedgerPage';
import TrialBalancePage from './pages/TrialBalancePage';
import AgingPage from './pages/AgingPage';
import SettingsPage from './pages/SettingsPage';
import AuditLogsPage from './pages/AuditLogsPage';
import NotificationsPage from './pages/NotificationsPage';
import ProfilePage from './pages/ProfilePage';
import GuidePage from './pages/GuidePage';
import LoadingScreen from './components/LoadingScreen';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/jadwalkan-demo" element={<ScheduleDemoPage />} />
      <Route path="/" element={<PrivateRoute><MainLayout /></PrivateRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="units" element={<UnitsPage />} />
        <Route path="warehouses" element={<WarehousesPage />} />
        <Route path="suppliers" element={<SuppliersPage />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="roles" element={<RolesPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="audit-logs" element={<AuditLogsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="guide" element={<GuidePage />} />
        
        {/* Inventory */}
        <Route path="inventory/stock" element={<StockPage />} />
        <Route path="inventory/stock-card" element={<StockCardPage />} />
        <Route path="inventory/opname" element={<StockOpnamePage />} />
        <Route path="inventory/transfer" element={<StockTransferPage />} />
        <Route path="inventory/in" element={<StockInPage />} />
        <Route path="inventory/out" element={<StockOutPage />} />
        
        {/* Purchasing */}
        <Route path="purchasing/requests" element={<PurchaseRequestsPage />} />
        <Route path="purchasing/orders" element={<PurchaseOrdersPage />} />
        <Route path="purchasing/receipts" element={<PurchaseReceiptsPage />} />
        <Route path="purchasing/invoices" element={<PurchaseInvoicesPage />} />
        <Route path="purchasing/returns" element={<PurchaseReturnsPage />} />
        
        {/* Sales */}
        <Route path="sales/new" element={<SalesNewPage />} />
        <Route path="sales/history" element={<SalesHistoryPage />} />
        <Route path="sales/invoices" element={<SalesInvoicesPage />} />
        <Route path="sales/returns" element={<SalesReturnsPage />} />
        <Route path="sales/receivables" element={<SalesReceivablesPage />} />
        
        {/* Finance */}
        <Route path="finance/cash-bank" element={<CashBankPage />} />
        <Route path="finance/payables" element={<PayablesPage />} />
        <Route path="finance/receivables" element={<ReceivablesPage />} />
        <Route path="finance/accounts" element={<AccountsPage />} />
        <Route path="finance/journals" element={<JournalsPage />} />
        <Route path="finance/periods" element={<AccountingPeriodsPage />} />
        
        {/* Reports */}
        <Route path="reports/profit-loss" element={<ProfitLossPage />} />
        <Route path="reports/balance-sheet" element={<BalanceSheetPage />} />
        <Route path="reports/equity" element={<EquityReportPage />} />
        <Route path="reports/general-ledger" element={<GeneralLedgerPage />} />
        <Route path="reports/trial-balance" element={<TrialBalancePage />} />
        <Route path="reports/aging-receivable" element={<AgingPage type="receivable" />} />
        <Route path="reports/aging-payable" element={<AgingPage type="payable" />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
